import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Send } from "lucide-react";
import { BRAND_SHORT } from "@/lib/brand";

export default function EmailEngine() {
  const [status, setStatus] = useState(null);
  const [log, setLog] = useState([]);
  const [form, setForm] = useState({ to: "", subject: `${BRAND_SHORT} Notification`, title: "Subject line", body: "Body text…" });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const [s, l] = await Promise.all([api.get("/email/status"), api.get("/email/log")]);
    setStatus(s.data); setLog(l.data);
  };
  useEffect(() => { load(); }, []);

  const send = async () => {
    setBusy(true);
    try {
      const to = form.to.split(",").map(s => s.trim()).filter(Boolean);
      const r = await api.post("/email/send", { to, subject: form.subject, title: form.title, body: form.body });
      toast.success(`Email ${r.data.status}`);
      await load();
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">{BRAND_SHORT} Email Engine</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Notifications &amp; Scheduled Deliveries</h1>
        <p className="text-sm text-zinc-500 mt-1">{status?.configured ? `Resend configured · sender ${status.from}` : "Resend NOT configured — emails will be queued (set RESEND_API_KEY to enable real send)"}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5 space-y-3">
          <div className="flex items-center gap-2"><Mail size={14} className="text-blue-400"/><div className="font-display font-medium">Send Test Email</div></div>
          <input data-testid="email-to" value={form.to} onChange={e=>setForm({...form,to:e.target.value})} placeholder="recipient1@x.com, recipient2@x.com" className="w-full bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm"/>
          <input data-testid="email-subject" value={form.subject} onChange={e=>setForm({...form,subject:e.target.value})} placeholder="Subject" className="w-full bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm"/>
          <input data-testid="email-title" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} placeholder="Title" className="w-full bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm"/>
          <textarea data-testid="email-body" value={form.body} onChange={e=>setForm({...form,body:e.target.value})} rows={5} placeholder="Body…" className="w-full bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm"/>
          <button onClick={send} disabled={busy} data-testid="email-send" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded px-4 py-2"><Send size={14}/>{busy?"Sending…":"Send"}</button>
        </div>

        <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
          <div className="font-display font-medium mb-3">Log ({log.length})</div>
          <div className="space-y-2 max-h-96 overflow-y-auto">
            {log.map(l => (
              <div key={l.id} className="border border-zinc-900 rounded p-2 text-xs">
                <div className="font-mono text-zinc-500">{l.at?.slice(0,16).replace("T"," ")} · <span className={`${l.status === 'sent' ? 'text-emerald-400' : l.status?.startsWith('error') ? 'text-red-400' : 'text-amber-400'}`}>{l.status}</span></div>
                <div className="text-zinc-300 mt-1">→ {(l.to || []).join(", ")}</div>
                <div className="text-zinc-400">{l.subject}</div>
              </div>
            ))}
            {log.length === 0 && <div className="text-zinc-500 text-sm">No emails yet.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
